import { IUpcomingEvents } from '../interfaces/iUpcomingEvents';
import { IEvent } from '../interfaces/iEvent';

export class UpcomingEvents implements IUpcomingEvents {
	events: IEvent[];
	shortlistedEvents: IEvent[];
	featuredEvent: IEvent;

	constructor(upcomingEvents: IUpcomingEvents = {} as IUpcomingEvents) {
	}
}



// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/upcomingEvents.ts